module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_remer",
    attrs: {
      "epub:type": "acknowledgments"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_IX",
      "title": "IX"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig2",
      "src": "images/chap2.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev2"
  }, [_c('b', [_vm._v("We have attempted to write ")])]), _vm._v("a readable book that provides a useful discussion of basic philosophical distinctions relevant for doing theology and for constructing and defending a Christian worldview. Many have helped us in this undertaking. We wish to thank our dear colleagues in the Talbot philosophy department—William Lane Craig, David Horner, and Scott Rae—for the deep friendship, vibrant Christian testimonies, and philosophical stimulation they regularly provide. We are grateful to our graduate assistants Brian Pinkston, Scott Sevier, and Gary Osmundsen for serving us so cheerfully and skillfully in preparing this book. We are grateful to Biola University for providing a faculty development grant to help fund our research and writing. J. P. Moreland is thankful to the Eidos Christian Center for providing him similar resources. As always, Jim Hoover has done an excellent job as editor for InterVarsity Press, and we are grateful to him for his hard work. Our wives, Barbara DeWeese and Hope Moreland, simply give us what we need to carry on. It is hard to conceive of this book’s coming into being without their love and commitment to the cause of Christ. Finally, we are grateful to each other. We have been friends for thirty years now, and it is a joy to write a book together. Of course, any mistakes in the book are due to my coauthor (a vicious circle indeed).")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 66
// module chunks = 0